
/* INVENTORY */
export const GET_INVENTORY_LISTING = "GET_INVENTORY_LISTING";
export const GET_INVENTORY_LISTING_SUCCESS = "GET_INVENTORY_LISTING_SUCCESS";
export const GET_INVENTORY_LISTING_FAIL = "GET_INVENTORY_LISTING_FAIL";

export const GET_INVENTORY_DETAILS = "GET_INVENTORY_DETAILS";
export const GET_INVENTORY_DETAILS_SUCCESS = "GET_INVENTORY_DETAILS_SUCCESS";
export const GET_INVENTORY_DETAILS_FAIL = "GET_INVENTORY_DETAILS_FAIL";

export const GET_INVENTORY_FILTERS = "GET_INVENTORY_FILTERS";
export const GET_INVENTORY_FILTERS_SUCCESS = "GET_INVENTORY_FILTERS_SUCCESS";
export const GET_INVENTORY_FILTERS_FAIL = "GET_INVENTORY_FILTERS_FAIL";

export const GET_INVENTORY_STOCK_STATUSES = "GET_INVENTORY_STOCK_STATUSES";
export const GET_INVENTORY_STOCK_STATUSES_SUCCESS = "GET_INVENTORY_STOCK_STATUSES_SUCCESS";
export const GET_INVENTORY_STOCK_STATUSES_FAIL = "GET_INVENTORY_STOCK_STATUSES_FAIL";

export const CREATE_INVENTORY = "CREATE_INVENTORY";
export const CREATE_INVENTORY_SUCCESS = "CREATE_INVENTORY_SUCCESS";
export const CREATE_INVENTORY_FAIL = "CREATE_INVENTORY_FAIL";

export const UPDATE_INVENTORY = "UPDATE_INVENTORY";
export const UPDATE_INVENTORY_SUCCESS = "UPDATE_INVENTORY_SUCCESS";
export const UPDATE_INVENTORY_FAIL = "UPDATE_INVENTORY_FAIL";

export const DELETE_INVENTORY = "DELETE_INVENTORY";
export const DELETE_INVENTORY_SUCCESS = "DELETE_INVENTORY_SUCCESS";
export const DELETE_INVENTORY_FAIL = "DELETE_INVENTORY_FAIL";

export const RESET_INVENTORY_STATE = 'RESET_INVENTORY_STATE';
export const RESET_INVENTORY_ACTION_STATE = 'RESET_INVENTORY_ACTION_STATE';

